import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { reset, resetPasswordForEmail } from "../../../redux/auth/authSlice";
import Loader from "../../../components/Loader";
import { toast } from "react-toastify";
import Layout from "../../../components/layout/Layout";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet";
import { DiscoverInvozio } from "../DiscoverInvozio";

const ResetPassword = () => {
  const { t } = useTranslation();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const dispatch = useDispatch();
  const { isLoading, isSuccess, isError, message } = useSelector(
    (state) => state.auth
  );

  useEffect(() => {
    return () => dispatch(reset());
  }, [dispatch]);

  useEffect(() => {
    if (isError) {
      toast.error(t(message));
      dispatch(reset());
    }
  }, [isError, message, dispatch, t]);

  useEffect(() => {
    if (isSuccess) {
      toast.success(
        t(
          "We have sent you an email with instructions on how to reset your password."
        )
      );
      dispatch(reset());
    }
  }, [isSuccess, dispatch, t]);

  const onSubmit = (values) => {
    dispatch(resetPasswordForEmail(values.email));
  };

  return (
    <Layout
      className="d-flex login new_sign_desns new_sign_up new_margin_header"
      hidefooter
      headerColor="secondary"
    >
      <Helmet>
        <link
          rel="canonical"
          href="https://invozio.com/glomt-ditt-losenord"
        />
      </Helmet>
      {isLoading && <Loader />}
      <div className="logn_pge_dsgn mobile">
        <div className="container">
          <div className="row">
            <div className="col-md-6 col-sm-8">
              <DiscoverInvozio />
            </div>
            <div className="col-md-6 col-sm-8">
              <div className="bg-light rest_frm mt-0">
                <form
                  className="m-auto text-center reset"
                  onSubmit={handleSubmit(onSubmit)}
                >
                  <h1 className="mb-3 text-dark">{t("Reset Password")}</h1>
                  <p className="mb-3 text-left">
                    {t(
                      "Enter the e-mail address you provided when creating your account. A link for password reset will be sent to the specified address."
                    )}
                  </p>
                  <input
                    type="text"
                    className="form-control mb-3"
                    placeholder={t("Email")}
                    required
                    {...register("email", {
                      pattern: {
                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                        message: t("Invalid email address"),
                      },
                    })}
                  />
                  {Object.keys(errors).length > 0 && (
                    <div className="text-center w-100">
                      <p className="text-danger">
                        {errors[Object.keys(errors)[0]].message}
                      </p>
                    </div>
                  )}
                  <Button
                    variant="primary "
                    type="submit"
                    className="mt-4 text-light filled mb-3 new_theme_btn"
                    size="lg"
                  >
                    {t("Send")}
                  </Button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default ResetPassword;
